var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94523 0.719727H3.68316C2.23008 0.719727 1.05212 1.89768 1.05212 3.35076V8.61283C1.05212 10.0659 2.23008 11.2439 3.68316 11.2439H8.94523C10.3983 11.2439 11.5763 10.0659 11.5763 8.61283V3.35076C11.5763 1.89768 10.3983 0.719727 8.94523 0.719727Z",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 5.65058C8.48389 6.08851 8.40909 6.53577 8.20518 6.92874C8.00128 7.32171 7.67865 7.64038 7.2832 7.83943C6.88774 8.03847 6.43959 8.10775 6.00249 8.03742C5.56539 7.96708 5.1616 7.76071 4.84855 7.44766C4.5355 7.13461 4.32913 6.73082 4.25879 6.29372C4.18845 5.85662 4.25774 5.40847 4.45678 5.01301C4.65582 4.61756 4.97449 4.29493 5.36746 4.09103C5.76044 3.88712 6.2077 3.81232 6.64563 3.87726C7.09234 3.9435 7.5059 4.15166 7.82522 4.47098C8.14455 4.79031 8.35271 5.20387 8.41895 5.65058Z",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20837 3.08789H9.2135",
    stroke: "#D6B893",
    strokeWidth: 1.05241,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.629,
    height: 12.629,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.2922a11ccb07463213e7b3cc99e40362.svg";
export { ForwardRef as ReactComponent };